module.exports = "<ion-label class=\"label\" *ngIf=\"transferAmount > 0\">Pending Funds {{transferAmount | currency}}</ion-label>\n"